var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 131,
    viewBox: "0 0 136 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1369 22.3771L46.9495 20.6438C33.3978 20.0122 25.3619 27.3317 24.7303 40.882L22.9988 78.0306C22.3672 91.581 29.6875 99.6162 43.2391 100.248L80.4266 101.981C93.9782 102.613 101.979 95.2917 102.61 81.7413L104.342 44.5927C104.973 31.0424 97.6886 23.0088 84.1369 22.3771Z",
    fill: "url(#paint0_linear_21_362)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_21_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7317 72.6101L88.0173 47.0592C88.4836 37.7912 84.0561 32.1586 76.0045 31.7535L48.7345 30.3814C40.5508 29.9697 35.6859 35.1347 35.2196 44.4027L33.934 69.9536C33.4602 79.371 37.7898 84.8458 45.9734 85.2576L73.2434 86.6297C81.2951 87.0348 86.2579 82.0275 86.7317 72.6101Z",
    fill: "#3F97FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_21_362)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_21_362",
    maskUnits: "userSpaceOnUse",
    x: 27.5267,
    y: 29.0078,
    width: 103.02,
    height: 103.02,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 27.5267,
    y: 29.0078,
    width: 103.02,
    height: 103.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.781 48.012L73.3123 36.714C60.3871 32.5969 50.7313 37.5873 46.6141 50.5125L35.3269 85.9471C31.2097 98.8723 36.2002 108.528 49.1254 112.645L84.5937 123.943C97.5189 128.06 107.141 123.059 111.258 110.134L122.545 74.6995C126.663 61.7743 121.706 52.1292 108.781 48.012"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.781 48.012L73.3123 36.714C60.3871 32.5969 50.7313 37.5873 46.6141 50.5125L35.3269 85.9471C31.2097 98.8723 36.2002 108.528 49.1254 112.645L84.5937 123.943C97.5189 128.06 107.141 123.059 111.258 110.134L122.545 74.6995C126.663 61.7743 121.706 52.1292 108.781 48.012",
    fill: "#3989E8",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.477 48.9648C109.003 49.1325 109.566 48.8418 109.733 48.3155C109.901 47.7893 109.61 47.2268 109.084 47.0592L108.477 48.9648ZM109.084 47.0592C108.558 46.8916 107.995 47.1823 107.828 47.7085C107.66 48.2347 107.951 48.7972 108.477 48.9648L109.084 47.0592ZM109.084 47.0592L73.6158 35.7612L73.0088 37.6668L108.477 48.9648L109.084 47.0592ZM73.6158 35.7612C66.9761 33.6462 61.0431 33.8315 56.2011 36.334C51.359 38.8365 47.7763 43.5693 45.6613 50.209L47.5669 50.816C49.5691 44.5306 52.8729 40.3055 57.1193 38.1107C61.3658 35.916 66.7233 35.6647 73.0088 37.6668L73.6158 35.7612ZM45.6613 50.209L34.374 85.6436L36.2797 86.2506L47.5669 50.816L45.6613 50.209ZM34.374 85.6436C32.259 92.2833 32.4443 98.2163 34.9469 103.058C37.4494 107.9 42.1821 111.483 48.8218 113.598L49.4289 111.692C43.1434 109.69 38.9183 106.387 36.7236 102.14C34.5289 97.8936 34.2775 92.5361 36.2797 86.2506L34.374 85.6436ZM48.8218 113.598L84.2902 124.896L84.8972 122.99L49.4289 111.692L48.8218 113.598ZM84.2902 124.896C90.93 127.011 96.8551 126.823 101.689 124.317C106.523 121.812 110.096 117.076 112.211 110.438L110.305 109.831C108.303 116.117 105.007 120.345 100.769 122.542C96.5311 124.738 91.1826 124.993 84.8972 122.99L84.2902 124.896ZM112.211 110.438L123.498 75.003L121.593 74.396L110.305 109.831L112.211 110.438ZM123.498 75.003C125.613 68.3644 125.437 62.4344 122.943 57.5947C120.449 52.7545 115.724 49.1742 109.084 47.0592L108.477 48.9648C114.763 50.967 118.979 54.2678 121.165 58.5108C123.352 62.7542 123.595 68.1093 121.593 74.396L123.498 75.003Z",
    fill: "url(#paint1_linear_21_362)",
    mask: "url(#path-3-outside-1_21_362)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_21_362)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_21_362",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2189 57.9246C84.4978 57.3764 82.629 58.3423 82.07 60.0971L69.7937 98.6365C69.2455 100.358 70.2114 102.226 71.9325 102.775C73.6874 103.334 75.5562 102.368 76.1045 100.647L88.3807 62.1074C88.9397 60.3525 87.9738 58.4836 86.2189 57.9246ZM64.5345 64.7348C62.8134 64.1866 60.9445 65.1525 60.3855 66.9073L52.076 92.994C51.5277 94.7151 52.4936 96.5839 54.2147 97.1322C55.9696 97.6912 57.8385 96.7253 58.3867 95.0042L66.6963 68.9175C67.2553 67.1627 66.2894 65.2938 64.5345 64.7348ZM91.1649 91.8774C91.7239 90.1225 93.5927 89.1566 95.3476 89.7156C97.0687 90.2638 98.0346 92.1327 97.4756 93.8876L93.552 106.205C93.0037 107.926 91.1348 108.892 89.38 108.333C87.6589 107.785 86.693 105.916 87.2412 104.195L91.1649 91.8774Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2189 57.9246C84.4978 57.3764 82.629 58.3423 82.07 60.0971L69.7937 98.6365C69.2455 100.358 70.2114 102.226 71.9325 102.775C73.6874 103.334 75.5562 102.368 76.1045 100.647L88.3807 62.1074C88.9397 60.3525 87.9738 58.4836 86.2189 57.9246ZM64.5345 64.7348C62.8134 64.1866 60.9445 65.1525 60.3855 66.9073L52.076 92.994C51.5277 94.7151 52.4936 96.5839 54.2147 97.1322C55.9696 97.6912 57.8385 96.7253 58.3867 95.0042L66.6963 68.9175C67.2553 67.1627 66.2894 65.2938 64.5345 64.7348ZM91.1649 91.8774C91.7239 90.1225 93.5927 89.1566 95.3476 89.7156C97.0687 90.2638 98.0346 92.1327 97.4756 93.8876L93.552 106.205C93.0037 107.926 91.1348 108.892 89.38 108.333C87.6589 107.785 86.693 105.916 87.2412 104.195L91.1649 91.8774Z",
    fill: "url(#paint2_linear_21_362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3855 66.9073L60.7667 67.0287L60.3855 66.9073ZM52.076 92.994L51.6949 92.8726L52.076 92.994ZM58.3867 95.0042L58.0056 94.8828L58.3867 95.0042ZM66.6963 68.9175L67.0774 69.0389L66.6963 68.9175ZM97.4756 93.8876L97.0945 93.7662L97.4756 93.8876ZM93.552 106.205L93.9331 106.327L93.552 106.205ZM82.4511 60.2186C82.9439 58.6715 84.5896 57.8254 86.0975 58.3058L86.3403 57.5435C84.4061 56.9274 82.314 58.013 81.6888 59.9757L82.4511 60.2186ZM70.1749 98.7579L82.4511 60.2186L81.6888 59.9757L69.4126 98.5151L70.1749 98.7579ZM72.0539 102.394C70.5433 101.912 69.6937 100.269 70.1749 98.7579L69.4126 98.5151C68.7973 100.447 69.8795 102.541 71.8111 103.156L72.0539 102.394ZM75.7233 100.525C75.243 102.033 73.6009 102.886 72.0539 102.394L71.8111 103.156C73.7738 103.781 75.8695 102.702 76.4856 100.768L75.7233 100.525ZM87.9996 61.9859L75.7233 100.525L76.4856 100.768L88.7618 62.2288L87.9996 61.9859ZM86.0975 58.3058C87.6419 58.7977 88.4915 60.4416 87.9996 61.9859L88.7618 62.2288C89.3879 60.2634 88.3057 58.1695 86.3403 57.5435L86.0975 58.3058ZM60.7667 67.0287C61.2595 65.4817 62.9051 64.6356 64.4131 65.116L64.6559 64.3537C62.7217 63.7376 60.6296 64.8232 60.0044 66.7859L60.7667 67.0287ZM52.4571 93.1154L60.7667 67.0287L60.0044 66.7859L51.6949 92.8726L52.4571 93.1154ZM54.3362 96.751C52.8255 96.2699 51.9759 94.626 52.4571 93.1154L51.6949 92.8726C51.0796 94.8042 52.1617 96.898 54.0933 97.5133L54.3362 96.751ZM58.0056 94.8828C57.5252 96.3907 55.8832 97.2438 54.3362 96.751L54.0933 97.5133C56.056 98.1385 58.1517 97.0598 58.7678 95.1256L58.0056 94.8828ZM66.3151 68.7961L58.0056 94.8828L58.7678 95.1256L67.0774 69.0389L66.3151 68.7961ZM64.4131 65.116C65.9575 65.6079 66.8071 67.2518 66.3151 68.7961L67.0774 69.0389C67.7034 67.0736 66.6213 64.9797 64.6559 64.3537L64.4131 65.116ZM95.469 89.3345C93.5036 88.7084 91.4098 89.7906 90.7837 91.7559L91.546 91.9988C92.0379 90.4544 93.6818 89.6048 95.2262 90.0967L95.469 89.3345ZM97.8567 94.009C98.4819 92.0463 97.4033 89.9506 95.469 89.3345L95.2262 90.0967C96.7342 90.5771 97.5873 92.2191 97.0945 93.7662L97.8567 94.009ZM93.9331 106.327L97.8567 94.009L97.0945 93.7662L93.1708 106.084L93.9331 106.327ZM89.2586 108.714C91.2213 109.34 93.317 108.261 93.9331 106.327L93.1708 106.084C92.6905 107.592 91.0484 108.445 89.5014 107.952L89.2586 108.714ZM86.8601 104.074C86.2448 106.005 87.327 108.099 89.2586 108.714L89.5014 107.952C87.9908 107.471 87.1412 105.827 87.6223 104.316L86.8601 104.074ZM90.7837 91.7559L86.8601 104.074L87.6223 104.316L91.546 91.9988L90.7837 91.7559Z",
    fill: "url(#paint3_linear_21_362)",
    mask: "url(#path-5-inside-2_21_362)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21_362",
    x: 9.96118,
    y: 7.60608,
    width: 107.418,
    height: 107.413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21_362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_21_362",
    x: 20.8989,
    y: 17.3585,
    width: 80.1519,
    height: 82.2939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_21_362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_21_362",
    x: 17.9172,
    y: 19.3043,
    width: 122.042,
    height: 122.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21_362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_21_362",
    x: 36.9224,
    y: 42.7711,
    width: 75.7122,
    height: 80.7209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_362"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223529 0 0 0 0 0.537255 0 0 0 0 0.909804 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_21_362",
    result: "effect2_dropShadow_21_362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_21_362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_362",
    x1: 69.2828,
    y1: 66.9155,
    x2: -2.25392,
    y2: 97.6701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3989E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_362",
    x1: 62.3332,
    y1: 42.9604,
    x2: 91.6604,
    y2: 118.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_362",
    x1: 44.0231,
    y1: 81.1509,
    x2: 50.738,
    y2: 127.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_362",
    x1: 70.3009,
    y1: 58.6095,
    x2: 88.721,
    y2: 101.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.deed58af0e91ac00d05a6277ab8c1238.svg";
export { ForwardRef as ReactComponent };